"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const Icon_1 = __importDefault(require("../../../common/js/atoms/Icon"));
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const translation_1 = require("../../../common/js/helper/translation");
const DataLayerEvents_1 = __importDefault(require("../../enums/DataLayerEvents"));
const DataLayerLabels_1 = __importDefault(require("../../enums/DataLayerLabels"));
const dataLayer_1 = require("../../helper/dataLayer");
const ShortCutItem = ({ item }) => {
    const title = (0, translation_1.t)(item.title);
    const description = (0, translation_1.t)(item.description);
    return (react_1.default.createElement(react_router_dom_1.Link, { to: item.url, className: "znd-dashboard-shortcut-item", onClick: () => {
            (0, dataLayer_1.pushToDataLayer)({
                event: DataLayerEvents_1.default.dlvDashboardShortcutClick,
                [DataLayerLabels_1.default.dlvDashboardShortcut]: title,
            });
        } },
        react_1.default.createElement("div", { className: "znd-dashboard-shortcut-item__icon" },
            react_1.default.createElement(Icon_1.default, { name: item.icon })),
        react_1.default.createElement("div", { className: "znd-dashboard-shortcut-item__text" },
            react_1.default.createElement("div", { className: "znd-dashboard-shortcut-item__text-title t-subhead-2" }, title),
            description.length > 0 && (react_1.default.createElement("div", { className: "--white-space-normal znd-dashboard-shortcut-item__text-body t-body-small" }, description))),
        react_1.default.createElement("div", { className: "znd-dashboard-shortcut-item__link" },
            react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.arrowRight }))));
};
exports.default = (0, react_i18next_1.withTranslation)()(ShortCutItem);
